@if (order) {
  @if (forbiddenEdit()) {
    @if (order.status.id == orderStatus.Submitted) {
      <div class="flex center padding bg-orange">
        <i class="fa fa-circle-info margin-right-smallest"></i>
        Order is submitted. Data editing is not available.
      </div>
    } @else if (order.status.id == orderStatus.ShootCompleted) {
      <div class="flex center padding bg-green white">
        <i class="fa fa-circle-info margin-right-smallest"></i>
        Shoot is completed. Data editing is not available.
      </div>
    }
  }

  <div class="padding-large m-padding">
    <div class="page-layout-small">
      <div class="flex between m-column m-start">
        <div class="flex center">
          <h4>Order Informations</h4>
        </div>

        <div class="flex center m-full-width m-margin-top">
          <button class="m-flex-1 {{ forbiddenEdit() ? 'disabled' : '' }}" (click)="saveChanges()">
            <mat-icon class="small margin-right-smallest">save</mat-icon>
            Save changes
          </button>
        </div>
      </div>
      <div class="flex column border radius margin-top">
        @if (!isNew) {
          <div class="bg-lightest-blue padding-large m-padding">
            <div class="grid-filter margin-bottom">
              <div class="flex column">
                <b>Order ID</b>
                <div class="margin-top-smallest bg-white border radius padding-small">
                  <h4>{{ order?.id }}</h4>
                </div>
              </div>

              <div class="flex column">
                <b>Status</b>
                <div class="flex margin-top-smallest">
                  <div class="flex-1 bg-white border radius padding-small">
                    <h4 class="normal primary">{{ order?.status?.name }}</h4>
                  </div>
                </div>
              </div>
            </div>
            <b>
              <i class="fa fa-gear margin-right-smallest"></i>
              AS400
            </b>
            <div class="flex column border radius padding bg-white m-padding margin-top-smallest margin-bottom">
              <div class="grid-filter">
                <div class="flex column">
                  <small class="grey">BasicNet ID</small>
                  <div class="margin-top-smallest border padding-small">
                    <h4>{{ order?.basicNetId ?? '-' }}</h4>
                  </div>
                </div>

                <div class="flex column">
                  <small class="grey">Shipping date</small>
                  <div class="flex margin-top-smallest border padding-small primary">
                    <h4>{{ (order?.waybill?.shippingDate | date: 'dd/MM/yyyy') || '-' }}</h4>
                  </div>
                </div>

                <div class="flex column">
                  <small class="grey">Waybill details</small>
                  <div class="flex margin-top-smallest">
                    <div class="flex-1 border padding-small primary">
                      <h4>{{ order?.waybill?.waybillNumber || '-' }}</h4>
                    </div>
                    <button
                      type="button"
                      class="radius-left-none {{ order?.waybill?.shippingDate ? '' : 'disabled' }}"
                      (click)="downloadShippingLabel()"
                    >
                      <i class="fa fa-download"></i>
                      Download
                      <span class="grey margin-left-smallest">(.pdf)</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <b>
              <i class="fa fa-receipt margin-right-smallest"></i>
              Procurement
            </b>
            <div class="flex bg-white column border radius padding margin-top-smallest m-padding">
              <div class="grid-filter">
                <div class="flex column">
                  <small class="grey">Service Order No.</small>
                  <div class="margin-top-smallest border padding-small">
                    <h4>{{ order.procurement?.serviceOrderId ?? '-' }}</h4>
                  </div>
                </div>

                <div class="flex column">
                  <small class="grey">Status</small>
                  <div class="flex center between wrap margin-top-smallest border padding-small">
                    <h4 class="normal {{ getProcurementStatusColor() }}">{{ getProcurementStatusLabel() }}</h4>
                    @if (order.procurement?.updateDate) {
                      <span class="small grey">
                        Updated {{ order.procurement?.updateDate | date: 'dd/MM/yyyy HH:mm' }}
                      </span>
                    }
                  </div>
                </div>

                <div class="flex column">
                  <small class="grey">Message</small>
                  <div class="margin-top-smallest border padding-small">
                    @if (showProcurementMessage()) {
                      <span class="{{ getProcurementStatusColor() }}">{{ order.procurement?.message }}</span>
                    } @else {
                      <h4>-</h4>
                    }
                  </div>
                </div>
              </div>
            </div>
          </div>
        }

        <div class="padding-large m-padding">
          <div class="grid-filter">
            <div class="flex-1 flex column">
              <div class="flex center between">
                <b>
                  Photographer
                  @if (!orderValidation.photographer) {
                    <span class="red margin-left">Required field</span>
                  }
                </b>
                <button
                  type="button"
                  class="radius-bottom-none {{ forbiddenEdit() ? 'disabled' : '' }}"
                  (click)="openEditPhotographerModal(); orderValidation.photographer = true"
                >
                  <i class="fa-solid fa-edit"></i>
                  Edit
                </button>
              </div>
              <div class="border blue padding flex center">
                @if (order?.photographer) {
                  <div class="placeholder bg-primary white">
                    <i class="fa fa-user"></i>
                  </div>
                  <div class="flex column margin-left-small">
                    {{ order?.photographer?.fullName }}
                    <div class="flex center primary hover margin-top-smallest disabled">
                      View Details
                      <i class="fa-solid fa-arrow-up-right-from-square margin-left-smallest"></i>
                    </div>
                  </div>
                } @else {
                  Select a photographer
                }
              </div>

              <div class="flex column margin-top">
                <b>Order type</b>
                <div class="flex center margin-top-small {{ forbiddenEdit() ? 'disabled' : '' }}">
                  <div class="flex gap center">
                    @for (type of orderTypes; track type) {
                      <div
                        class="flex center column {{
                          type.selected ? 'border border-blue bg-lightest-blue' : ''
                        }} padding-small hover "
                        (click)="selectOrderType(type)"
                      >
                        <div class="flex-1">
                          <div class="placeholder {{ type.name }}"></div>
                        </div>

                        <div class="flex-0 flex column margin-top-smallest">
                          <b>{{ type.name }}</b>
                        </div>
                      </div>
                    }
                  </div>
                </div>
              </div>
              <!-- 
              <div class="flex column margin-top">
                <b>Synchronization options</b>
                <div class="flex column gap margin-top-small  full-width {{ forbiddenEdit() ? 'disabled' : '' }}">
                  <div
                    class="flex column padding border  hover full-width  {{
                      order.isFake ? '' : 'border-blue bg-lightest-blue'
                    }}"
                    (click)="selectSynchronization(true)"
                  >
                    <div class="flex center">
                      @if (!order.isFake) {
                        <i class="fa fa-check margin-right-smallest"></i>
                      }
                      <b>Default synchronization (Warehouse, AS400, Procurement)</b>
                    </div>

                    <span class="grey">
                      This order will be synchronized by default. The products will be picked up from the warehouse and
                      synchronized with AS400 systems and procurement.
                    </span>
                  </div>

                  <div
                    class="flex column padding border hover full-width {{
                      order.isFake ? 'border-blue bg-lightest-blue' : ''
                    }}"
                    (click)="selectSynchronization(false)"
                  >
                    <div class="flex center">
                      @if (order.isFake) {
                        <i class="fa fa-check margin-right-smallest"></i>
                      }
                      <b>No synchronization</b>
                    </div>

                    <span class="grey">
                      This order will not be synchronized. The product
                      <b>will not</b>
                      be picked up from the warehouse and
                      <b>will not</b>
                      be synchronized with AS400 systems and procurement.
                    </span>
                  </div>
                </div>
              </div>

			-->

              <div class="flex column margin-top">
                <b>
                  Creation date
                  <i class="margin-left-smallest fa fa-lock grey"></i>
                </b>
                <div class="flex margin-top-smallest disabled">
                  <input
                    type="text"
                    class="flex-1"
                    [matDatepicker]="creationDatePicker"
                    matInput
                    [(ngModel)]="order.creationDate"
                  />
                  <mat-datepicker #creationDatePicker></mat-datepicker>
                  <button class="radius-left-none" (click)="creationDatePicker.open()">
                    <mat-icon class="small margin-right-smallest">calendar_month</mat-icon>
                    Edit
                  </button>
                </div>
              </div>

              <div class="flex column margin-top">
                <b>
                  Due date
                  @if (!orderValidation.dueDate) {
                    <span class="red margin-left">Required field</span>
                  }
                </b>
                <div class="flex margin-top-smallest">
                  <input
                    type="text"
                    class="flex-1"
                    [matDatepicker]="dueDatePicker"
                    matInput
                    [min]="todayDate"
                    [(ngModel)]="order.dueDate"
                  />
                  <mat-datepicker #dueDatePicker></mat-datepicker>
                  <button
                    class="radius-left-none {{ forbiddenEdit() ? 'disabled' : '' }}"
                    (click)="dueDatePicker.open(); orderValidation.dueDate = true"
                  >
                    <mat-icon class="small margin-right-smallest">calendar_month</mat-icon>
                    Edit
                  </button>
                </div>
              </div>

              <div class="flex column margin-top">
                <b>Other options:</b>
                <div class="flex column gap margin-top-small  full-width {{ !!order.id ? 'disabled' : '' }}">
                  <div class="flex column">
                    <div class="flex center hover" (click)="toggleSynchronization()">
                      <i
                        class="primary-dark   margin-right-smallest fa {{
                          order.isFake ? 'fa-solid fa-check-square' : 'fa-regular fa-square'
                        }}"
                      ></i>
                      Disable synchronization
                    </div>

                    <span class="grey">
                      This order will not be synchronized. The product
                      <b>will not</b>
                      be picked up from the warehouse and
                      <b>will not</b>
                      be synchronized with AS400 systems and procurement.
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div class="flex-1 flex column">
              <b>Notes</b>
              <textarea
                class="full-height full-width margin-top-smallest"
                matInput
                [(ngModel)]="order.notes"
                style="resize: none; overflow: auto"
              ></textarea>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
}
@if (loading) {
  <bt-loader></bt-loader>
}
